import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import {
  Text,
  IconButton,
  IconCopy,
  IconEdit,
  Space,
  IconDelete,
} from '@redlink/components/atoms';
import { useValues } from '@redlink/assets/values';

export const InnerLinkItem = memo(
  ({
    pageName,
    item: { title, token } = {},
    onEditPressed,
    onCopyPressed,
    onDeletePressed,
  }) => {
    const { styles, colors } = useStyle();
    const { getLinkUrl } = useValues();
    return (
      <View style={styles.linkContainer}>
        <View style={styles.textsContainer}>
          <Text style={styles.titleText}>{title}</Text>
          <Text en style={styles.subtitleText} numberOfLines={1}>
            {getLinkUrl(pageName, token)}
          </Text>
        </View>
        <View style={styles.iconsContainer}>
          <IconButton
            transparent
            style={styles.actionButton}
            onPress={onCopyPressed}
          >
            <IconCopy size={18} color={colors.black} />
          </IconButton>
          <Space size={8} />
          <IconButton
            transparent
            style={styles.actionButton}
            onPress={onDeletePressed}
          >
            <IconDelete size={20} color={colors.black} />
          </IconButton>
          <Space size={8} />
          <IconButton
            transparent
            style={styles.actionButton}
            onPress={onEditPressed}
          >
            <IconEdit size={18} color={colors.black} />
          </IconButton>
        </View>
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors, size }) => ({
  linkContainer: {
    borderWidth: 1,
    borderColor: colors.black3,
    borderRadius: 4,
    flexDirection: 'row',
    paddingVertical: 8,
    paddingHorizontal: 16,
  },
  textsContainer: {
    flex: 1,
  },
  titleText: {
    fontWeight: '500',
    fontSize: 16,
    color: colors.gray23,
    textAlign: 'left',
  },
  subtitleText: {
    fontSize: 12,
    color: colors.gray21,
    textAlign: 'left',
  },
  iconsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  actionButton: {
    width: 24,
    height: 24,
  },
}));
